import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import ExpandableSection from 'components/Shared/Layout/ExpandableSection';
import Button from 'components/Shared/Common/Button';
import classNames from 'classnames';
import { Tooltip } from 'antd';
import { StyledExpandableSection, StyledExpandableSectionTitle } from 'components/Shared/style';

class ExpandableSectionWithTitle extends PureComponent {
    render() {
        const {
            title,
            onAdd,
            addUrl,
            children,
            isLoading,
            id,
            placeholder,
            target,
            tooltip,
            ...otherProps
        } = this.props;
        let content = null;

        if (children) {
            content = (
                <ExpandableSection {...otherProps}>
                    {children}
                </ExpandableSection>
            );
        } else {
            content = placeholder;
        }

        return (
            <StyledExpandableSection 
                className={classNames(
                    'ui-content-channel-group',
                    {
                        'loading' : isLoading
                    }
                )}
            >
                <StyledExpandableSectionTitle className="ui-content-channel-group-title">
                    {title}
                    {(onAdd || addUrl) && (
                        <Tooltip title={tooltip}>
                            <div className="action" id={id}>
                                <Button
                                    iconName="PlusCircle"
                                    onClick={onAdd}
                                    href={addUrl}
                                    target={target || (addUrl ? '_blank' : undefined)}
                                />
                            </div>
                        </Tooltip>
                    )}
                </StyledExpandableSectionTitle>
                {content}
            </StyledExpandableSection>
        );
    }
}

ExpandableSectionWithTitle.propTypes = {
    title: PropTypes.string.isRequired,
    tooltip: PropTypes.string.isRequired,
    addUrl: PropTypes.string,
    target: PropTypes.string,
    onAdd: PropTypes.func,
    children: PropTypes.any,
    id: PropTypes.string.isRequired,
    isLoading: PropTypes.bool,
    placeholder: PropTypes.any
};

ExpandableSectionWithTitle.defaultProps = {
    onAdd: undefined,
    addUrl: undefined,
    target: undefined,
    isLoading: true,
    children: null,
    placeholder: null
};

export default ExpandableSectionWithTitle;
